import styled from "styled-components";

const HeaderContainer = styled.div`
    background-color: ${props => props.theme.palette.primary.medium};
    background: ${props => props.theme.palette.primary.gradient};
    padding-top: 30px;
    padding-bottom: 20px;
    text-align: center;
    margin-left: 0px;

    /* Phones */
    @media only screen and (max-width: 767px) {
    }

`;

const MainTitle = styled.h1`
    font-size: 40px;
    color: ${props => props.theme.palette.primary.contrastText};
    margin-bottom: 0;

    /* Phones */
    @media only screen and (max-width: 767px) {
        font-size: 30px;
    }
`;

const MainSubtitle = styled.h6`
    font-size: 14px;
    margin-top: 0.5rem;
    margin-bottom: 0;
    color: ${props => props.theme.palette.primary.contrastText};

    /* Phones */
    @media only screen and (max-width: 767px) {
        font-size: 10px;
    }
`;


function Header() {
    return (
        <HeaderContainer>
            <MainTitle>Music Search Tool</MainTitle>
            <MainSubtitle>Powered by the Spotify® API</MainSubtitle>
        </HeaderContainer>
    );
}

export default Header;
